/* Main */

import cart from './pages/cart';
import homePage from './pages/home';
import singleProduct from './pages/singleProduct';


